import * as React from "react"
import styled from "@emotion/styled"
import Rating from "@material-ui/lab/Rating"
import { withStyles } from "@material-ui/core/styles"
import { SendRounded, StarRounded } from "@material-ui/icons"
import { opacify } from "polished"
import Gmail from "../../assets/mobile/svg/gmail.inline.svg"
import Linked from "../../assets/mobile/svg/linked.inline.svg"
import Skype from "../../assets/mobile/svg/skype.inline.svg"
import Behance from "../../assets/mobile/svg/behance.inline.svg"
import { theme, rr } from "../../styles/styleGuide"
var color = theme.color,
  font = theme.font

function Contact() {
  var rate = 0
  const Form = () => {
    const Form = styled.form`
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      width: 80vw;
      padding-top: 27%;
      .hidden-input {
        visibility: hidden;
      }
      ${rr("font-size", "vw", 6, 5, 4)}
    `
    const Email = () => {
      const Email = styled.input`
        font-size: 0.8em;
        position: relative;
        box-sizing: border-box;
        /* padding: 0.8vw; */
        /* border: none; */
        ${rr("border", ` solid ${color.white}`, "0.25em")}
        width: 100%;
        padding: 0.6em;
        margin: 0.8em;
        /* height: 15%; */
        background-color: transparent;
        color: ${color.white};
        ${font.content.medium};
        &:hover {
          background-color: rgba(255, 255, 255, 0.118);
        }
        &:focus {
          background-color: rgba(0, 0, 0, 0.364);
        }
        &:active {
          background-color: rgba(0, 0, 0, 0.364);
        }
        &:focus-visible {
          outline: none;
        }
      `
      return <Email id="email" type="email" placeholder="@email" name="email" />
    }
    const Text = () => {
      const TextAreat = styled.textarea`
        font-size: 0.8em;
        width: 100%;
        height: 35%;
        position: relative;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: scroll;
        padding: 0.6em;
        margin: 0.8em;
        /* border-bottom: solid 0.3vw ${color.white}; */
        ${rr("border", ` solid ${color.white}`, "0.25em")}
        color: ${color.white};
        ${font.content.medium};
        /* padding: 1.6em 1.1em;
        padding-top: 1vw;
        padding-right: 3vw;
        padding-left: 3vw; */
        /* line-height: 1.5; */
        background-color: transparent;
        &:hover {
          background-color: rgba(255, 255, 255, 0.118);
        }
        &:focus {
          background-color: rgba(0, 0, 0, 0.364);
        }
        &:active {
          background-color: rgba(0, 0, 0, 0.364);
        }
        &:focus-visible {
          outline: none;
        }
      `
      return <TextAreat id="text" placeholder="Your Opinion Matters ...." name="content" />
    }
    const Rate = () => {
      const Stars = withStyles({
        iconFilled: {
          color: color.yellow,
        },
        iconHover: {
          color: opacify(-0.2, color.yellow),
        },
      })(Rating)

      const StarsCustom = styled(Stars)`
        position: relative;
        font-size: 1.6em !important;
      `
      const Lable = styled.label`
        font-size: 0.9em;
        color: ${color.yellow};
        ${font.content.medium};
        margin: 0.2em;
      `
      const Holder = styled.div`
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        width: 100%;
        height: 15%;
        border: none;
        color: ${color.white};
        font-size: 1.1em;
        margin-top: 0.3em;
        margin-bottom: 0.1em;
      `
      return (
        <Holder>
          <Lable>
            <b>Rate my work!</b>
          </Lable>
          <StarsCustom
            id="rate"
            defaultValue={0}
            name="rating"
            size="large"
            icon={<StarRounded fontSize="inherit" />}
            onClick={(e: any) => (rate = e.target.value)}
          />
        </Holder>
      )
    }
    const clickFb = () => {
      var Email = document.querySelector<HTMLInputElement>("#contact #email")?.value,
        Text = document.querySelector<HTMLInputElement>("#contact #text")?.value,
        Form = document.querySelector<HTMLFormElement>("#contact #form"),
        Rate = rate
      ;(Email || Text || Rate) && Form?.submit()
    }
    const Send = () => {
      const Icon = styled(SendRounded)`
        transform: scale(1.5);
        color: ${color.contactBlue};
        margin-left: 1em;
        font-size: 0.9em !important;
      `
      const Lable = styled.span`
        color: ${color.contactBlue};
        font-size: 1.2em;
        ${font.content.bold};
      `
      const Holder = styled.button`
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 50%;
        border-radius: 5px;
        border: none;
        ${rr("margin-top", "vh", 4, 3, 2)}
        padding: 0.5em 0.3em;
        background-color: #fff;
      `
      return (
        <Holder type="submit" onClick={clickFb}>
          <Lable className="text">Send</Lable>
          <Icon className="icon" />
        </Holder>
      )
    }

    return (
      <>
        <Form
          id="form"
          action="./thanks"
          target="_blank"
          name="Portfolio-Website"
          method="post"
          netlify-honeypot="bot-field"
          data-netlify="true"
        >
          <input className="hidden-input" type="hidden" name="bot-field" />
          <input
            className="hidden-input"
            type="hidden"
            name="form-name"
            value="Portfolio-Website"
          />
          <Email />
          <Text />
          <Rate />
          <Send />
        </Form>
      </>
    )
  }
  return (
    <Container id="contacts">
      <Clip className="clip">
        <Form />
        <MediaButtons />
        <Border />
      </Clip>
      <Title />
    </Container>
  )
}
const Container = styled.div`
  position: absolute;
  bottom: 0;
  width: 100vw;
  ${rr("height", "vh", 91.4)}
  overflow: hidden;
`
const Border = styled.div`
  position: absolute;
  pointer-events: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  ${rr("border", ` solid ${color.contacts.cover.background}`, "2.4vw", "2.4vw", "2.1vw")}
  box-sizing: border-box;
`
const Clip = styled.div`
  height: 100%;
  width: 100%;
  clip-path: inset(0% 0% 0% 0%);
  background-color: ${color.contacts.cover.primary};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
`
const Title = () => {
  const Text = styled.div`
    ${rr("font-size", "vw", 17, 17, 15)}
    text-align: center;
    color: ${color.contacts.cover.primary};
    line-height: 1.1;
    ${font.title}
  `
  const Border = styled.div`
    position: absolute;
    width: 100vw;
    height: 12%;
    top: 0;
    left: 0;
    background-color: ${color.contacts.cover.background};
  `

  return (
    <Border className="section-title">
      <Text>contacts</Text>
    </Border>
  )
}
const MediaButtons = () => {
  const Button = styled.a`
    position: relative;
    /* margin: 1vh 3vw; */
    ${rr("margin", "", "0.7vh 7.2vw", "1vh 7.5vw", "1vh 9vw")}
    svg {
      ${rr("width", "vw ", 8, 6.5, 5)}
      transform:scale(2);
    }
  `
  const Holder = styled.div`
    position: absolute;
    bottom: 0;
    width: 100vw;
    height: 18vh;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    /* background-color: #d50000; */
  `
  return (
    <Holder>
      <Button href="mailto:abdallaelhosini@gmail.com?cc=abdallaworks@gmail.com" target="_blank">
        <Gmail />
      </Button>
      <Button href="https://www.linkedin.com/in/abdalla-hossainy/" target="_blank">
        <Linked />
      </Button>
      <Button href="https://msng.link/o/?abdallaelhosini@gmail.com=sk" target="_blank">
        <Skype />
      </Button>
      <Button href="https://www.behance.net/abdalla-hossainy" target="_blank">
        <Behance />
      </Button>
    </Holder>
  )
}

export default Contact
